import { Flex } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router';

import { Button, ButtonVariant, Modal, Typography } from '@/shared/ui';

import { Breakpoints, useMediaQuery } from '@/hooks/useMediaQuery';

import { ROUTES } from '@/router/config';

interface SubmitNotAvailableModalProps {
  isOpen: boolean;
  full_name: string;
  createNewRequest: () => void;
  onClose: () => void;
}

export const SubmitNotAvailableModal: React.FC<SubmitNotAvailableModalProps> = ({
  full_name,
  createNewRequest,
  isOpen,
  onClose,
}) => {
  const isMobileSize = useMediaQuery(Breakpoints.SM);
  const navigate = useNavigate();

  return (
    <Modal
      closable
      onCancel={onClose}
      open={isOpen}
      title="Зверніть увагу!"
      footer={
        <Flex gap={8} vertical={isMobileSize}>
          <Button
            onClick={() => {
              onClose();
              createNewRequest();
            }}
          >
            Подати новий запит
          </Button>
          <Button
            variant={ButtonVariant.SECONDARY}
            onClick={() => {
              onClose();
              navigate(ROUTES.USER.REQUESTS.ACTIVE_REQUESTS);
            }}
          >
            Перейти в Мої запити
          </Button>
        </Flex>
      }
    >
      <Typography>У вас вже є поданий запит на розгляді на особу {full_name}.</Typography>
      <Typography>Якщо ви подасте запит на цю саму особу він не буде розглянутий.</Typography>
      <Typography>Якщо ви плануєте подавати запит на іншу особу - натисність кнопку “Подати новий запит”.</Typography>
    </Modal>
  );
};
